import { between } from '@hotjar/insights-common/lib/between';

import { HeatmapIndicatorState, TrafficCoverageLevel } from './types';

export const getTrafficCoverageLevelByPercentage = (
  coveragePercentage: number | undefined,
): TrafficCoverageLevel => {
  if (!coveragePercentage || Number.isNaN(coveragePercentage)) {
    return TrafficCoverageLevel.VeryLow;
  }

  if (between(coveragePercentage, 0, 25)) {
    return TrafficCoverageLevel.VeryLow;
  }

  if (between(coveragePercentage, 26, 50)) {
    return TrafficCoverageLevel.Low;
  }

  if (between(coveragePercentage, 51, 75)) {
    return TrafficCoverageLevel.Medium;
  }

  if (between(coveragePercentage, 76, 99)) {
    return TrafficCoverageLevel.High;
  }

  if (coveragePercentage > 99) {
    return TrafficCoverageLevel.Max;
  }

  return TrafficCoverageLevel.VeryLow;
};

export const getHeatmapIndicatorState = ({
  days,
  coverageLevel,
  filtersApplied,
  isError,
}: {
  days: number;
  coverageLevel: TrafficCoverageLevel;
  filtersApplied: boolean;
  isError: boolean;
}): HeatmapIndicatorState => {
  if (filtersApplied) {
    return HeatmapIndicatorState.FILTERS_APPLIED;
  }
  if (isError) {
    return HeatmapIndicatorState.UNAVAILABLE;
  }
  if (days < 1) {
    return HeatmapIndicatorState.MEASURING;
  }
  // In contrast to the traffic widget, we group
  // "low" and "very low" coverage levels into the "low" state
  if (
    coverageLevel === TrafficCoverageLevel.VeryLow ||
    coverageLevel === TrafficCoverageLevel.Low
  ) {
    return HeatmapIndicatorState.LOW;
  }
  if (coverageLevel === TrafficCoverageLevel.Medium) {
    return HeatmapIndicatorState.MID;
  }
  if (coverageLevel === TrafficCoverageLevel.High) {
    return HeatmapIndicatorState.HIGH;
  }
  if (coverageLevel === TrafficCoverageLevel.Max) {
    return HeatmapIndicatorState.MAX;
  }
  // fallback state
  return HeatmapIndicatorState.UNAVAILABLE;
};
